<template>
  <TablePermissionPossession />
</template>
<script>
import TablePermissionPossession from "./components/tablePermissionPossession";
export default {
  components: {
    TablePermissionPossession,
  },
  methods: {},
  created() {},
};
</script>
<style></style>
